/* Grace Theory — global helpers: scroll reveal + video toggle */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.gt-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 4, 3) * 80 + 'ms';
      io.observe(el);
    });
  }

  function videos(scope) {
    (scope || document).querySelectorAll('[data-gt-video-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var video = btn.closest('.gt-video').querySelector('video');
      if (!video) { btn.hidden = true; return; }
      if (reduce) { video.pause(); btn.classList.add('is-paused'); btn.setAttribute('aria-label', 'Play video'); }
      btn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          btn.classList.remove('is-paused');
          btn.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          btn.classList.add('is-paused');
          btn.setAttribute('aria-label', 'Play video');
        }
      });
    });
  }

  function boot(scope) { reveal(scope); videos(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
